import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import PageActions from "../../../../base/PageActions";
import ContentBox from "../../../../../components/content-box/ContentBox";
import _http_service from "../../../../../services/HttpService";
import _device_service from "../../../../../services/DeviceService";
import _image_service from "../../../../../services/ImageService";
import '../../../../styles/Common.scss';
import './DownloadSuperFoxPage.scss';

interface DownloadSuperFoxPageProps {
}

const DownloadSuperFoxPage = (props: DownloadSuperFoxPageProps) => {

    const page: PageActions = new PageActions({
        title: `Downloads: Super Fox - Chase the Fox`,
        description: "Download Chase's free-to-use Super Fox 2D Vtuber model, based on Super Animal Royale!",
        keywords: ["download", "downloadable", "super fox", "super animal royale", "vtuber", "free vtuber", "2d vtuber", "free download", "vtuber download"],
        imgSrc: `chase/assets/super_fox_icon.png`,
        url: `downloads/super-fox`
    });

    const [error, setError] = useState<string>('');

    // TODO: Make reusable link button component
    const handleDownload = (): void => {
        setError('');
        _http_service.getDownloadLocation("super-fox")
            .then(downloadLocation => {
                _device_service.setBrowserUrl(downloadLocation);
            })
            .catch(() => setError('Failed to fetch file. Please try again!'));
    };

    return page.generateMetaContent(
        <ContentBox header="Super Fox Vtuber">
            <div className="download-examples">
                <img
                    className="download-example"
                    src={_image_service.getCdnImageSrc(`chase/assets/super_fox_example1.png`)}
                    alt="Super Fox Vtuber in action!"
                    title="Super Fox Vtuber in action!"/>
                <img
                    className="right download-example"
                    src={_image_service.getCdnImageSrc(`chase/assets/super_fox_example2.png`)}
                    alt="Super Fox Vtuber in action!"
                    title="Super Fox Vtuber in action!"/>
            </div>
            <p className="center">
                This Super Fox 2D Vtuber model is recreated from the art style of Super Animal Royale! It's free-to-use
                and can be imported into Vtube Studio or your 2D vtube program of choice. It has a few unique features
                that give it life and makes it customizable for your SAR stream or other applications:
            </p>
            <div className="download-features">
                <ul className="separated-list-elements">
                    <li>Full RGB sliders</li>
                    <li>Multiple expressions</li>
                    <li>Head bob while talking</li>
                    <li>Physics enabled on the ears</li>
                </ul>
            </div>
            <p className="center">
                If you use this on your Twitch stream, please consider crediting my website
                or <NavLink to="/stream" target="_blank" rel="noopener noreferrer">my stream</NavLink>: ChaseTheRedFox
                on your page! If you'd like to support this and future creations,
                please <a href='https://ko-fi.com/R5R06FLC8' target='_blank' rel="noopener noreferrer">buy me a Ko-fi</a>!
                If you have any questions, feel free
                to <NavLink to="/contact" target="_blank" rel="noopener noreferrer">contact me</NavLink>!
            </p>
            <p className="center">
                <em>
                    Note: This is an unofficial fan artwork of Super Animal Royale. All rights to Super Animal Royale
                    are owned by Pixile Studios.
                </em>
            </p>
            <p className="center">
                <button className="download-button" onClick={handleDownload}>
                    Download the latest version of the Super Fox 2D Vtuber model
                </button>
            </p>
            <p className="center download-error">{error}</p>
        </ContentBox>
    );
}

export default DownloadSuperFoxPage;